import * as React from 'react'

import { Button, List } from '@factorialco/deprecated-design-system'
import { EvaluationFormListItemFragment } from 'generated/resources/graphql'
import { useToggle } from 'usehooks-ts'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import { DeleteEvaluationForm } from 'modules/ats/components/EvaluationForm/components/DeleteEvaluationForm'

import { CreateEvaluationFormTemplateSidepanel } from '../CreateEvaluationFormTemplate/CreateEvaluationFormTemplateSidepanel'
import { EditEvaluationFormTemplateSidepanel } from '../EditEvaluationFormTemplate/EditEvaluationFormTemplateSidepanel'

interface Props {
  evaluationForm: EvaluationFormListItemFragment
}

export const ListItem = ({ evaluationForm }: Props) => {
  const [showDeleteModal, setShowDeleteModal] = useToggle(false)
  const [editEvaluationFormTemplateOpen, setEditEvaluationFormTemplate] = useToggle(false)
  const [duplicateEvaluationFormTemplateOpen, setDuplicateEvaluationFormTemplate] = useToggle(false)

  return (
    <List.ClickableItem navigateTo={() => null}>
      <List.Title>{evaluationForm.name}</List.Title>

      <List.ActionItem>
        <PopoverMenu type="list">
          <PopoverMenu.Trigger>
            <Button.Decorative
              type="secondary"
              aria-label={i18n.t('ats.evaluation_forms.settings.options', {
                template_name: evaluationForm.name,
              })}
              iconName="ellipsis"
            />
          </PopoverMenu.Trigger>
          <PopoverMenu.Content side="bottom" align="center">
            <PopoverMenu.TouchableOption
              title={i18n.t('common.edit')}
              onClick={setEditEvaluationFormTemplate}
            />
            <PopoverMenu.TouchableOption
              title={i18n.t('common.duplicate')}
              onClick={setDuplicateEvaluationFormTemplate}
            />
            <PopoverMenu.TouchableOption
              title={i18n.t('common.delete')}
              onClick={setShowDeleteModal}
              danger
            />
          </PopoverMenu.Content>
        </PopoverMenu>
      </List.ActionItem>

      {editEvaluationFormTemplateOpen && (
        <EditEvaluationFormTemplateSidepanel
          onClose={setEditEvaluationFormTemplate}
          evaluationFormId={evaluationForm.id}
        />
      )}

      {duplicateEvaluationFormTemplateOpen && (
        <CreateEvaluationFormTemplateSidepanel
          onClose={setDuplicateEvaluationFormTemplate}
          evaluationFormId={evaluationForm.id}
          duplicate
        />
      )}

      {showDeleteModal && (
        <DeleteEvaluationForm evaluationForm={evaluationForm} onClose={setShowDeleteModal} />
      )}
    </List.ClickableItem>
  )
}
